export enum SelectListTrigger {
  BOOKMARK_BUTTON_SINGLE_ENTITY,
}
